import React from 'react';
export const DoctorStory = () => {
  return <section className="mb-12" data-id="element-113">
      <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-114">
        <div className="md:w-1/3" data-id="element-115">
          <img src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Dr. Sarah Grant" className="rounded-full shadow-lg w-48 h-48 object-cover mx-auto" data-id="element-116" />
        </div>
        <div className="md:w-2/3" data-id="element-117">
          <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-118">
            Dr. Sarah Grant knew her patients had a problem.
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-119">
            After 15 years as one of Manhattan's most sought-after
            dermatologists, she was watching her patients spend thousands on
            treatments that barely lasted a few months... while they went home
            every night to sleep on the very thing that was aging them faster
            than time itself.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-120">
            "I was trapped," she reveals. "I knew the real cause of what I was
            seeing in 60% of my patients' facial aging wasn't genetics or sun
            damage. It was friction. It was what my patients were sleeping on
            every single night."
          </p>
          <p className="text-gray-700 mb-4" data-id="element-121">
            But here's the thing that kept her up at night: She couldn't tell
            them.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-122">
            Not officially. Not in her practice. Because the moment she
            recommended a £59 solution over £375 Botox treatments, her entire
            industry would turn against her.
          </p>
        </div>
      </div>
      <blockquote className="italic text-xl text-blue-900 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-123">
        "The anti-aging industry isn't built on cures," Dr. Grant finally
        admits. "It's built on customers. And customers who solve their
        problems... aren't customers anymore."
      </blockquote>
      <p className="text-gray-700" data-id="element-124">
        Today, Dr. Grant is breaking her silence about the £59 anti-aging
        breakthrough that could revolutionize how we think about aging. But
        first, she wants you to understand exactly why she - and thousands of
        dermatologists like her - have been forced to stay quiet.
      </p>
    </section>;
};